export const statTileStyles = theme => ({
  tile: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    minHeight: 72,
  },
  label: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.06em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  value: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#00205B',
    wordBreak: 'break-word',
  },
})
